// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"spinner__page-spinner___1OZzs","pageSpinner":"spinner__page-spinner___1OZzs","spin":"spinner__spin___3ZRIr","small":"spinner__small___3tw7w"};